import { LOAD_SOURCE_FILE } from './';

export default (path: string) => ({
  type: LOAD_SOURCE_FILE,
  payload: path,
});
